import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import PageDescription from '../../components/page-description';
import MoreButton from '../../components/more-button';
import { MoreIcon } from '../../components/icons';
import CategoryActions from '../../containers/category-actions';
import withAuth from '../../hoc/with-auth';
import styles from './category-description.scss';

const CategoryDescription = ({ category, isAuthenticated, isCoverVisible }) => {
  let actions;

  if (isAuthenticated) {
    const icon = <MoreIcon fill={_.get(category, 'textColor.color')}/>;
    actions = (
      <div className={styles.actions}>
        <MoreButton icon={icon}>
          <CategoryActions category={category}/>
        </MoreButton>
      </div>
    );
  }

  return (
    <PageDescription
      title={category.label}
      description={category.description}
      cover={category.cover}
      coverType={category.coverType}
      overlayColor={category.overlayColor}
      backgroundColor={category.backgroundColor}
      textColor={category.textColor}
      isCoverVisible={isCoverVisible}
    >
      {actions}
    </PageDescription>
  );
};

CategoryDescription.propTypes = {
  category: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  isCoverVisible: PropTypes.bool.isRequired,
};

export default withAuth(CategoryDescription);



// WEBPACK FOOTER //
// ./app/components/category-description/category-description.js